import { createSlice } from "@reduxjs/toolkit";
import _dropRight from 'lodash/dropRight';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import { 
  getEsignTemplates, 
  getEsignTemplate, 
  createEsignTemplate, 
  updateEsignTemplate, 
  deleteEsignTemplate,
  clearLocalEsignTemplates,
  clearLocalActiveEsignTemplate
} from "./actions";

export const initialState = {
  all: { 
    data: [], 
    pagination: { limit: 25, offset: 0, count: 0, total_count: 0 } 
  },
  esignTemplate: { 
    id: '', 
    created_at: '', 
    updated_at: '', 
    template: { id: '', name: '', file: null, pages: [], elements: [], pages_count: 0, created_at: '', updated_at: '' } 
  },
  loading: { 
    all: false, 
    esignTemplate: false 
  }
};

const  slice = createSlice({
  name: 'esignTemplates',
  initialState,
  reducers: {
    clearLocalEsignTemplates: (state) => {
      state.all = initialState.all;
    },
    clearLocalActiveEsignTemplate: (state) => {
      state.esignTemplate = initialState.esignTemplate;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(getEsignTemplates.pending, (state) => {
        state.loading.all = true;
      })
      .addCase(getEsignTemplates.fulfilled, (state, action) => {
        const { esign_templates, pagination } = action.payload;
        
        state.loading.all = false;
        state.all = { ...state.all, data: [...state.all.data, ...esign_templates], pagination };
      })
      .addCase(getEsignTemplates.rejected, (state) => {
        state.loading.all = false;
      })
      .addCase(getEsignTemplate.pending, (state) => {
        state.loading.esignTemplate = true;
      })
      .addCase(getEsignTemplate.fulfilled, (state, action) => {
        const { esign_template } = action.payload;
        const data = _map(state.all.data, (item) => item.id === esign_template.id ? { ...item, ...esign_template } : item);
        const updatedEsignTemplate = { ...state.esignTemplate, ...esign_template };
        
        state.loading.esignTemplate = false;
        state.all = { ...state.all, data };
        state.esignTemplate = updatedEsignTemplate;
      })
      .addCase(getEsignTemplate.rejected, (state) => {
        state.loading.esignTemplate = false;
      })
      .addCase(createEsignTemplate.pending, (state) => {
        state.loading.esignTemplate = true;
      })
      .addCase(createEsignTemplate.fulfilled, (state, action) => {
        const { esign_template } = action.payload;
        const isPageFull = state.all.pagination.count % state.all.pagination.limit === 0 && state.all.pagination.total_count > 0;
        const oldAllData = isPageFull ? _dropRight(state.all.data) : state.all.data;
        const data = [...[esign_template], ...oldAllData];
        const pagination = { ...state.all.pagination, count: isPageFull ? state.all.pagination.count : state.all.pagination.count + 1, total_count: state.all.pagination.total_count + 1 };
        
        state.loading.esignTemplate = false;
        state.all = { ...state.all, data, pagination };
        state.esignTemplate = { ...state.esignTemplate, esign_template };
      })
      .addCase(createEsignTemplate.rejected, (state) => {
        state.loading.esignTemplate = false;
      })
      .addCase(updateEsignTemplate.pending, (state) => {
        state.loading.esignTemplate = true;
      })
      .addCase(updateEsignTemplate.fulfilled, (state, action) => {
        const { status, esignTemplate } = action.payload;
        const updatedEsignTemplate = { ...state.esignTemplate, ...esignTemplate };
        const data = _map(state.all.data, (item) => item.id === esignTemplate.id ? { ...item, ...esignTemplate } : item);
        
        state.loading.esignTemplate = false;
        if (status === 204) {
          state.all = { ...state.all, data };
          state.esignTemplate = updatedEsignTemplate; 
        } 
      })
      .addCase(updateEsignTemplate.rejected, (state) => {
        state.loading.esignTemplate = false;
      })
      .addCase(deleteEsignTemplate.pending, (state) => {
        state.loading.esignTemplate = true;
      })
      .addCase(deleteEsignTemplate.fulfilled, (state, action) => {
        const { status, id } = action.payload;
        const data = _filter(state.all.data, (item) => item.id !== id);
        const pagination = { ...state.all.pagination, count: state.all.pagination.count - 1, total_count: state.all.pagination.total_count - 1 };
        
        state.loading.esignTemplate = false;
        if (status === 204) {
          state.all = { data, pagination };
        }
      })
      .addCase(deleteEsignTemplate.rejected, (state) => {
        state.loading.esignTemplate = false;
      })
      .addCase(clearLocalEsignTemplates, state => {
        state.all = initialState.all;
      })
      .addCase(clearLocalActiveEsignTemplate, state => {
        state.esignTemplate = initialState.esignTemplate;
      })
  }
})

export default slice.reducer;